import { render, staticRenderFns } from "./ImageVector.vue?vue&type=template&id=982eb2cc&scoped=true&"
import script from "./ImageVector.vue?vue&type=script&lang=js&"
export * from "./ImageVector.vue?vue&type=script&lang=js&"
import style0 from "./ImageVector.vue?vue&type=style&index=0&id=982eb2cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982eb2cc",
  null
  
)

export default component.exports